var ZipFileModule = (function () {
    function ZipFileModule() {
    }
    return ZipFileModule;
}());
export { ZipFileModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/zip-file/zip-file.module.ts.pre-build-optimizer.js